/** A tiny typed event emitter (core → React HUD). Pattern-only; does not import
 *  the editor or web-core's global emitter (this app is self-contained). */
export type Unsubscribe = () => void;

export class Emitter<Events> {
  private listeners = new Map<keyof Events, Set<(payload: never) => void>>();

  on<K extends keyof Events>(key: K, fn: (payload: Events[K]) => void): Unsubscribe {
    let set = this.listeners.get(key);
    if (!set) {
      set = new Set();
      this.listeners.set(key, set);
    }
    set.add(fn as (payload: never) => void);
    return () => {
      this.listeners.get(key)?.delete(fn as (payload: never) => void);
    };
  }

  off<K extends keyof Events>(key: K, fn: (payload: Events[K]) => void): void {
    this.listeners.get(key)?.delete(fn as (payload: never) => void);
  }

  emit<K extends keyof Events>(key: K, payload: Events[K]): void {
    this.listeners.get(key)?.forEach((fn) => (fn as (p: Events[K]) => void)(payload));
  }

  clear(): void {
    this.listeners.clear();
  }
}
